import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Message } from "./message.model";

@Injectable()
export class MessageService {

  readonly message$ = new BehaviorSubject<Message>(null);

}
